import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../../src/services/utilities/SessionStorageService';
import { isTargetRoleId } from '../utilities/roleUtility';
import { USER_ROLES } from '../utilities/constants';

/**
 * @description 労務安全へ遷移する前に sessionSelectedPartnerCompanyId を自社の ID へ変更する
 */
const setSessionSelectedPartnerCompanyIdBeforeMoveRoan = () => {
  let roleId = LocalStorageService.getRoleId();
  if (
    !isTargetRoleId([USER_ROLES.partner], roleId) &&
    !isTargetRoleId([USER_ROLES.foreman], roleId)
  ) {
    return;
  }

  let selectedCompanyId = null;
  if (isTargetRoleId([USER_ROLES.partner], roleId)) {
    selectedCompanyId = SessionStorageService.getSessionPartnerCompanyIdOfPrimeCompany();
  } else if (isTargetRoleId([USER_ROLES.foreman], roleId)) {
    selectedCompanyId = SessionStorageService.getCompanyId();
  }

  SessionStorageService.setSessionSelectedPartnerCompanyId(selectedCompanyId);
};

const RoanUtility = {
  setSessionSelectedPartnerCompanyIdBeforeMoveRoan,
};

export default RoanUtility;



// WEBPACK FOOTER //
// ./src/utilities/roanUtility.js